import React from 'react';
import 'react-toggle/style.css';

import ErrorBox from 'src/SharedComponents/ErrorBox';
import LoadingIndicator from 'src/SharedComponents/LoadingIndicator';
import { SessionContext } from 'src/Views/SessionContext';
import styled from 'styled-components';
import { getRhapsodyHeader, getRhapsodyUsers } from '../ramService';
import RhapsodyUserTable from './UserTable';
import IRhapsodyUser from 'src/ServerEntities/IRhapsodyUser';
import { RolesContext } from 'src/Roles/RolesContext';
import IRhapsodyServer from 'src/ServerEntities/IRhapsodyServer';
import { ContentContainer } from '../Intersystems/IntersystemsDashboard';
import ServerSelector from 'src/SharedComponents/Select/ServerSelector';
import useCookie from 'src/CustomHooks/useCookie';
import { isQVera } from './Queues';

interface IProps {
    selectedTypes: string[],
    changeRole: boolean,
    setChangeRole: (changeRole: boolean) => void
};

const SiteContainer = styled.div`
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: flex-start;
    align-items: stretch;
    margin-top: 20px;
    overflow: auto;
`;

const TitleBar = styled.div`
    width: 1035px;
    border-radius: 20px;
    background-color: #1577AE;
    padding: 5px;
    padding-left: 10px;
    color: #FFF;
    text-align: center;
    font-size: 1.2em;
    font-weight: bold;
`;

const MonitorUsers = (props: IProps) => {
    const { state, dispatch } = React.useContext(SessionContext);
    const [loading, setLoading] = React.useState(false);
    const [error, setError] = React.useState("");
    const [users, setUsers] = React.useState(undefined as unknown as IRhapsodyUser[]);
    const [data, setData] = React.useState(undefined as unknown as IRhapsodyServer[]);
    const [selectedNamespace, setSelectedNamespace] = useCookie<string>('selectedNamespace', '');
    const selectedServer = state.selectedSever ?? 0;

    const setSelectedServer = (index: number) => {
        dispatch({ type: "setSelectedServer", payload: index });
    };

    const roleContext = React.useContext(RolesContext);
    const currentRole = roleContext.state.role;
    const headerInfo = state.headerInfo ? state.headerInfo : data as IRhapsodyServer[];
    
    React.useEffect(() => {
        setLoading(true);
        getRhapsodyHeader(state.webToken, (serverData: IRhapsodyServer[]) => {
            if (serverData[selectedServer]) {
                getRhapsodyUsers(serverData[selectedServer].id, state.webToken, (data: IRhapsodyUser[]) => {
                    setUsers(data);
                    setError("");
                    setLoading(false);
                }, (errorMessage: string) => {
                    setError(errorMessage);
                    setLoading(false);
                });
            } else {
                setLoading(false);
            }
            setData(serverData);
            dispatch({ type: "setHeaderInfo", payload: serverData });
        }, (errorMessage: string) => {
            setLoading(false);
            setError(errorMessage);
        }, isQVera(headerInfo, selectedServer) ? undefined : selectedNamespace);
    }, [currentRole, selectedNamespace]);

    React.useEffect(() => {
        if (headerInfo && headerInfo[selectedServer]) {
            setLoading(true);
            getRhapsodyUsers(headerInfo[selectedServer].id, state.webToken, (data: IRhapsodyUser[]) => {
                setLoading(false);
                setUsers(data);
                setError("");
            }, (errorMessage: string) => {
                setLoading(false);
                setError(errorMessage);
            });
        }
    }, [selectedServer, headerInfo]);

    return <ContentContainer>
        <LoadingIndicator type="Linear" show={loading} />
        {error && <ErrorBox>{error}</ErrorBox>}
        {isQVera(headerInfo, selectedServer) ?
            <ServerSelector headerInfo={headerInfo} selectedServer={selectedServer} setSelectedServer={setSelectedServer} /> :
            <ServerSelector headerInfo={headerInfo} selectedNamespace={selectedNamespace} setSelectedNamespace={setSelectedNamespace} selectedServer={selectedServer} setSelectedServer={setSelectedServer} />
        }
        <SiteContainer>
            <TitleBar>Users</TitleBar>
            {users && <RhapsodyUserTable users={users} />}
        </SiteContainer>
    </ContentContainer>;
};

export default MonitorUsers;
